import { useRouter } from 'next/router'
import useSWRImmutable from 'swr/immutable'

import type { ApisType } from '@/legacy-src/store/createApis'

import { useApis } from '../contexts/api-context'

const fetchCompanyData = async (api: ApisType['api'], slug: string) => {
  const result = await api.getCompany(slug)
  return result.data
}

export const useGetCompany = () => {
  const { api } = useApis()
  const router = useRouter()
  const { data, mutate } = useSWRImmutable(
    () => (router.query.slug ? 'getCompany' : null),
    () => fetchCompanyData(api, router.query.slug as string),
  )

  return { data, fetchCompany: mutate }
}
